import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  // #region [POST] check-list-documetos/documentos-importacao
  postDocumentosImportacaoRenew: [],
  postDocumentosImportacaoRequest: ['files', 'idLista'],
  postDocumentosImportacaoResponse: ['success', 'data', 'error'],
  postDocumentosImportacaoUpdateFile: [
    'idFile',
    'success',
    'progress',
    'message',
  ],
  // #endregion

  // #region [GET] check-list-documetos/documentos-importacao/{id}/beneficiario-documento
  getDocumentosBeneficiarioRequest: ['idLista'],
  getDocumentosBeneficiarioResponse: ['success', 'data', 'error'],
  // #endregion

  // #region [GET] check-list-documetos/documentos-importacao/{id}/preview-documento/{idDocumento}
  getDocumentoPreviewRequest: ['idLista', 'idDocumento'],
  getDocumentoPreviewResponse: ['success', 'data', 'error'],
  // #endregion

  // #region [POST] check-list-documetos/documentos-importacao/{id}/atualiza-documento-conferencia/{idDocumento}
  postAtualizarDocumentoConferenciaRequest: [
    'idLista',
    'params',
    'callbackSuccess',
  ],
  postAtualizarDocumentoConferenciaResponse: ['success', 'data', 'error'],
  // #endregion

  // #region [POST] check-list-documetos/documentos-importacao/{id}/finaliza-conferencia
  postFinalizarConferenciaDocumentosRequest: ['idLista', 'callbackSuccess'],
  postFinalizarConferenciaDocumentosResponse: ['success', 'data', 'error'],
  // #endregion
});

// #region [POST] check-list-documetos/documentos-importacao
const documentosImportacao = {
  success: false,
  error: null,
  loading: false,
  data: {},
  files: [],
};
// #endregion

// #region [GET] check-list-documetos/documentos-importacao/{id}/beneficiario-documento
const documentosBeneficiarios = {
  loading: false,
  success: false,
  response: {
    lista: {},
    header: [],
    beneficiario: {},
  },
  error: null,
};
// #endregion

// #region [GET] check-list-documetos/documentos-importacao/{id}/preview-documento/{idDocumento}
const documentoPreview = {
  loading: false,
  success: false,
  response: {},
  error: null,
};
// #endregion

// #region [POST] check-list-documetos/documentos-importacao/{id}/atualiza-documento-conferencia/{idDocumento}
const documentoConferencia = {
  loading: false,
  success: false,
  data: {},
  error: null,
};
// #endregion

// #region [POST] check-list-documetos/documentos-importacao/{id}/finaliza-conferencia
const finalizarConferenciaDocumentos = {
  loading: false,
  success: false,
  data: {},
  error: null,
};
// #endregion

const INICIAL_STATE = {
  documentoPreview,
  documentoConferencia,
  documentosImportacao,
  documentosBeneficiarios,
  finalizarConferenciaDocumentos,
};

// #region [POST] check-list-documetos/documentos-importacao
const postDocumentosImportacaoRenew = (state = INICIAL_STATE) => ({
  ...state,
  documentosImportacao,
});

const postDocumentosImportacaoRequest = (state = INICIAL_STATE, action) => ({
  ...state,
  documentosImportacao: {
    ...documentosImportacao,
    loading: true,
    files: [...action.files],
  },
});

const postDocumentosImportacaoUpdateFile = (state = INICIAL_STATE, action) => ({
  ...state,
  documentosImportacao: {
    ...state.documentosImportacao,
    files: state.documentosImportacao.files.map((file) =>
      file.idFile === action.idFile
        ? {
            ...file,
            error: !action.success,
            progress: action.progress,
            message: action.message,
          }
        : file
    ),
  },
});

const postDocumentosImportacaoResponse = (state = INICIAL_STATE, action) => ({
  ...state,
  documentosImportacao: {
    ...state.documentosImportacao,
    success: action.success,
    error: action.error,
    loading: false,
    data: action.data,
  },
});
// #endregion

// #region [GET] check-list-documetos/documentos-importacao/{id}/beneficiario-documento
const getDocumentosBeneficiarioRequest = (state = INICIAL_STATE) => ({
  ...state,
  documentosBeneficiarios: {
    ...state.documentosBeneficiarios,
    loading: true,
  },
});
const getDocumentosBeneficiarioResponse = (state = INICIAL_STATE, action) => ({
  ...state,
  documentosBeneficiarios: {
    ...state.documentosBeneficiarios,
    loading: false,
    success: action.success,
    error: action.error,
    response: action.data,
  },
});
// #endregion

// #region [GET] check-list-documetos/documentos-importacao/{id}/preview-documento/{idDocumento}
const getDocumentoPreviewRequest = (state = INICIAL_STATE) => ({
  ...state,
  documentoPreview: {
    ...state.documentoPreview,
    loading: true,
  },
});

const getDocumentoPreviewResponse = (state = INICIAL_STATE, action) => ({
  ...state,
  documentoPreview: {
    ...state.documentoPreview,
    loading: false,
    success: action.success,
    error: action.error,
    response: action.data,
  },
});
// #endregion

// #region [POST] check-list-documetos/documentos-importacao/{id}/atualiza-documento-conferencia/{idDocumento}
const postAtualizarDocumentoConferenciaRequest = (state = INICIAL_STATE) => ({
  ...state,
  documentoConferencia: {
    ...state.documentoConferencia,
    loading: true,
  },
});

const postAtualizarDocumentoConferenciaResponse = (
  state = INICIAL_STATE,
  action
) => ({
  ...state,
  documentoConferencia: {
    ...state.documentoConferencia,
    loading: false,
    success: action.success,
    error: action.error,
    response: action.data,
  },
});
// #endregion

// #region [POST] check-list-documetos/documentos-importacao/{id}/finaliza-conferencia
const postFinalizarConferenciaDocumentosRequest = (state = INICIAL_STATE) => ({
  ...state,
  finalizarConferenciaDocumentos: {
    ...state.finalizarConferenciaDocumentos,
    loading: true,
  },
});

const postFinalizarConferenciaDocumentosResponse = (
  state = INICIAL_STATE,
  action
) => ({
  ...state,
  finalizarConferenciaDocumentos: {
    ...state.finalizarConferenciaDocumentos,
    loading: false,
    success: action.success,
    error: action.error,
    response: action.data,
  },
});
// #endregion

export default createReducer(INICIAL_STATE, {
  [Types.POST_DOCUMENTOS_IMPORTACAO_RENEW]: postDocumentosImportacaoRenew,
  [Types.POST_DOCUMENTOS_IMPORTACAO_REQUEST]: postDocumentosImportacaoRequest,
  [Types.POST_DOCUMENTOS_IMPORTACAO_RESPONSE]: postDocumentosImportacaoResponse,
  [Types.POST_DOCUMENTOS_IMPORTACAO_UPDATE_FILE]: postDocumentosImportacaoUpdateFile,

  [Types.GET_DOCUMENTOS_BENEFICIARIO_REQUEST]: getDocumentosBeneficiarioRequest,
  [Types.GET_DOCUMENTOS_BENEFICIARIO_RESPONSE]: getDocumentosBeneficiarioResponse,

  [Types.GET_DOCUMENTO_PREVIEW_REQUEST]: getDocumentoPreviewRequest,
  [Types.GET_DOCUMENTO_PREVIEW_RESPONSE]: getDocumentoPreviewResponse,

  [Types.POST_ATUALIZAR_DOCUMENTO_CONFERENCIA_REQUEST]: postAtualizarDocumentoConferenciaRequest,
  [Types.POST_ATUALIZAR_DOCUMENTO_CONFERENCIA_RESPONSE]: postAtualizarDocumentoConferenciaResponse,

  [Types.POST_FINALIZAR_CONFERENCIA_DOCUMENTOS_REQUEST]: postFinalizarConferenciaDocumentosRequest,
  [Types.POST_FINALIZAR_CONFERENCIA_DOCUMENTOS_RESPONSE]: postFinalizarConferenciaDocumentosResponse,
});
